// extracted by mini-css-extract-plugin
export default {"inactive":"ald_click-catcher__inactive__uJRth","tooltip":"ald_click-catcher__tooltip__OkS6i"};